import React, { useState } from 'react';
import { WhatsappIcon } from 'react-share';
import { ExclamationCircleFill, X } from 'react-bootstrap-icons';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import RecaptchaComponent from '../commonSection/RecaptchaComponent';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import flags from 'react-phone-number-input/flags';
import { submitLeadForm } from '../../redux/actions/micrositeAction';
import useMicroSiteEncrypt from '../CustomHook/useMicroSiteEncrypt';

// Helpers for handling YouTube vs normal video URLs
// Check if a URL is a YouTube link
const isYouTubeUrl = (urlString) => {
  if (!urlString) return false;
  try {
    const url = new URL(urlString);
    return url.hostname.includes("youtube.com") || url.hostname.includes("youtu.be");
  } catch (e) {
    return false;
  }
};

// Convert normal YouTube URL (watch / short / youtu.be) to embeddable URL
const getYouTubeEmbedUrl = (urlString) => {
  if (!urlString) return "";

  try {
    const url = new URL(urlString);

    // https://www.youtube.com/watch?v=VIDEO_ID
    if (url.hostname.includes("youtube.com")) {
      const videoId = url.searchParams.get("v");
      if (videoId) return `https://www.youtube.com/embed/${videoId}`;
    }

    // https://youtu.be/VIDEO_ID
    if (url.hostname.includes("youtu.be")) {
      const videoId = url.pathname.replace("/", "");
      if (videoId) return `https://www.youtube.com/embed/${videoId}`;
    }

    // Fallback: return original URL
    return urlString;
  } catch (e) {
    // If URL parsing fails, just return original string
    return urlString;
  }
};

const WhatsappPreviewModal = ({ tracking_details, colors }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [searchParams] = useSearchParams();
  
  return (
    <div>
      
        <Transition show={open}>
          <Dialog className="relative z-10" onClose={setOpen}>
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <TransitionChild
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full max-sm:w-full sm:max-w-xl">
                    <div className="px-4 py-8 max-sm:px-4 py-8">
                    <X className="absolute right-2 top-2 z-50 text-[#222] cursor-pointer text-2xl" 
                        onClick={() => { setOpen(false); }}
                    />
                    <div className="flex justify-center m-0 p-0">
                      {tracking_details?.c_type !== 'Video' && (
                        <img
                          src={ tracking_details?.wp_data?.image_url ? tracking_details?.wp_data?.image_url : tracking_details?.c_thumb_image}
                          alt="Whatsapp Preview"
                          className="w-full h-full object-cover"
                        />
                      )}

                      {tracking_details?.c_type === 'Video' &&
                        (isYouTubeUrl(tracking_details?.c_file) ? (
                          <iframe
                            src={getYouTubeEmbedUrl(tracking_details?.c_file)}
                            title="Whatsapp Preview Video"
                            className="w-full h-full object-cover h-[300px]"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        ) : (
                          <video
                            src={ tracking_details?.wp_data?.image_url ? tracking_details?.wp_data?.image_url : tracking_details?.c_file}
                            alt="Whatsapp Preview"
                            className="w-full h-full object-cover"
                            controls
                          />
                        ))}
                    </div>
                   
                  </div>
                  </DialogPanel>
                </TransitionChild>
              </div>
            </div>
          </Dialog>
        </Transition>
    </div>
  );
};

export default WhatsappPreviewModal;